(() => {
  const init = (root) => {
    if (root.dataset.js6v2Ready) return;
    root.dataset.js6v2Ready = 'true';
    const carousel = root.querySelector('[data-js6v2-carousel]');
    if (carousel) {
      const slides = [...carousel.querySelectorAll('[data-js6v2-slide]')];
      let current = 0;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; slide.inert = i !== current; });
        carousel.querySelector('[data-js6v2-slide-count]').textContent = `${String(current + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      };
      carousel.querySelector('[data-js6v2-prev]').addEventListener('click', () => show(current - 1));
      carousel.querySelector('[data-js6v2-next]').addEventListener('click', () => show(current + 1));
    }
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-js6v2-quote]');
      if (!link) return;
      const field = document.querySelector('[data-js6v2-requirements]');
      if (!field) { sessionStorage.setItem('js6-quote-item', link.dataset.js6v2Quote); return; }
      const line = link.dataset.js6v2Quote;
      if (!field.value.includes(line)) field.value += `${field.value.trim() ? '\n' : ''}${line}\n`;
      requestAnimationFrame(() => field.focus({preventScroll:true}));
    });
    const requirements = root.querySelector('[data-js6v2-requirements]');
    if (requirements) {
      const selected = sessionStorage.getItem('js6-quote-item');
      if (selected && !requirements.value) requirements.value = `${selected}\n`;
      sessionStorage.removeItem('js6-quote-item');
    }
    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-js6v2-cart-form]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button');
      if (button.disabled) return;
      const status = form.closest('.js6v2-card').querySelector('[data-js6v2-cart-status]');
      const label = button.textContent;
      button.disabled = true; button.setAttribute('aria-busy','true'); status.textContent = '';
      try {
        const response = await fetch(root.dataset.cartUrl, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : root.dataset.cartError);
        status.textContent = root.dataset.added;
        if (window.js6RefreshThemeCart) await window.js6RefreshThemeCart().catch(() => {});
      } catch (error) { status.textContent = error.message || root.dataset.cartError; }
      finally { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = label; }
    });
  };
  const start = () => document.querySelectorAll('[data-js6v2]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();


